import React, { useEffect } from 'react';
import {
  Route,
  Routes as ReactRoutes,
  useNavigate,
  useLocation,
} from 'react-router-dom';
import navigationManager from './NavigationManager';
import { ROUTES } from './routes';
import Contact from 'app/Pages/Contact';
import Home from '../app/Pages/Home';
import Matches from 'app/Pages/Matches';
import Live from '../app/Pages/Live';
import Teams from 'app/Pages/Teams';
import League from 'app/Pages/League';
import Tv from '../app/Pages/Tv';
import Header from 'components/Header';
import LeagueMatches from 'app/Pages/LeagueMatches';

const Routes: React.FC = () => {
  const navigate = useNavigate();
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  useEffect(() => {
    navigationManager.setNavigate(navigate);
  }, [navigate]);

  return (
    <ReactRoutes>
      <Route path="/" element={<Header />}>
        <Route path={ROUTES.CONTACT} element={<Contact />} />
        <Route path={ROUTES.HOME} element={<Home />} />
        <Route path={ROUTES.MATCHES} element={<Matches />} />
        <Route path={ROUTES.LIVE} element={<Live />} />
        <Route path={ROUTES.TEAMS} element={<Teams />} />
        <Route path={ROUTES.LEAGUE} element={<League />} />
        <Route path={ROUTES.LEAGUE_MATCHES} element={<LeagueMatches />} />
      </Route>

      <Route path={ROUTES.TV} element={<Tv />} />
    </ReactRoutes>
  );
};

export default Routes;
